/**
 * LERA Device Compatibility Collection bridge (DCF-003).
 *
 * On collection pages, when the URL carries the stable device parameter from
 * DCF-002 (?lera_device=...):
 *   1. If the official Search & Discovery filter for "Dispositivo compatible"
 *      is not applied yet, redirect once to the same URL with the filter
 *      appended — Shopify then filters the collection server-side.
 *   2. Reveal the server-rendered banner (snippets/lera-device-banner.liquid).
 *
 * Device detection is delegated to LERA.compatibility.getDeviceFromUrl()
 * (Device Engine, DCF-002) — no parallel parsing, no new index.
 * Without lera_device the script does nothing: the Premium collection
 * (facets, sorting, pagination, cards) is untouched.
 */
(function (global) {
  'use strict';

  if (global.__leraDeviceCollectionInit) return;
  global.__leraDeviceCollectionInit = true;

  var DEFAULT_FILTER_PARAM = 'filter.v.option.dispositivo-compatible';

  function getDeviceFromUrl() {
    var api = global.LERA && global.LERA.compatibility;
    if (!api || typeof api.getDeviceFromUrl !== 'function') return null;

    try {
      return api.getDeviceFromUrl();
    } catch (error) {
      return null;
    }
  }

  function getBanner() {
    return document.querySelector('[data-lera-device-banner]');
  }

  function getFilterParamName() {
    var banner = getBanner();
    return (banner && banner.getAttribute('data-filter-param')) || DEFAULT_FILTER_PARAM;
  }

  function revealBanner() {
    var banner = getBanner();
    if (banner) banner.hidden = false;
  }

  function run() {
    var device = getDeviceFromUrl();
    if (!device || !device.model) return;

    var paramName = getFilterParamName();
    var params = new URLSearchParams(global.location.search);

    if (!params.getAll(paramName).length) {
      // Apply the official Search & Discovery filter with a single redirect;
      // lera_device is preserved so the banner shows after the reload.
      params.append(paramName, device.model);
      global.location.replace(global.location.pathname + '?' + params.toString());
      return;
    }

    revealBanner();
    observeGridRerenders();
  }

  /**
   * facets.js re-renders #ProductGridContainer via Section Rendering, which
   * replaces the banner with a fresh (hidden) server-rendered copy. Re-reveal
   * it while the device is still present in the URL.
   */
  function observeGridRerenders() {
    var container = document.getElementById('ProductGridContainer');
    if (!container || typeof MutationObserver === 'undefined') return;

    new MutationObserver(function () {
      var device = getDeviceFromUrl();
      if (device && device.model) revealBanner();
    }).observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})(typeof window !== 'undefined' ? window : this);
